module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/sorority-mobile-01-b9d04242137c2b64714d9a3df2ec92a2.jpg";